export const SACHGEBIETE = [
  { code: 'AL', name: 'Arbeitslosenversicherung' },
  { code: 'KA', name: 'Vertragsarztangelegenheiten' },
  { code: 'KG', name: 'Kindergeld-/Erziehungsgeldangelegenheiten' },
  { code: 'KR', name: 'Krankenversicherung' },
  { code: 'P', name: 'Pflegeversicherung' },
  { code: 'R', name: 'Rentenversicherung' },
  { code: 'U', name: 'Unfallversicherung' },
  { code: 'VS', name: 'Entschädigungs-/Schwerbehindertenrecht' },
  { code: 'Z', name: 'Sonstige Angelegenheiten' },
  { code: 'SO', name: 'Sozialhilfe' },
  { code: 'AS', name: 'Grundsicherung für Arbeitsuchende' },
  { code: 'ÜG', name: 'Entschädigungsklage bei überlanger Verfahrensdauer' },
  { code: 'SB', name: 'Schwerbehindertenrecht' },
  { code: 'BA', name: 'Betriebsprüfungen' },
  { code: 'AY', name: 'Asylbewerberleistungsgesetz' },
  { code: 'KS', name: 'Künstlersozialversicherung' },
  { code: 'LW', name: 'Alterssicherung der Landwirte' },
  { code: 'BL', name: 'Blindengeld' },
  { code: 'SF', name: 'Sonstige Verfahren' }
];

export const KATEGORIEN = [
  { code: 'U', name: 'Urteil' },
  { code: 'B', name: 'Beschluss' },
  { code: 'G', name: 'Gerichtsbescheid' },
  { code: 'T', name: 'Teilurteil' },
  { code: 'K', name: 'Kostenbeschluss' }
]; 